import { Bot } from 'lucide-react';

import { EmptyResult } from '@/components/empty-result';

import { emit } from '@/hooks/use-event-handler';

import { useAgentsListStore } from '@/store/agents-list.store';

export const AgentEmptyResult = () => {
  const { query, reset, filters } = useAgentsListStore();

  const hasQuery = (query && query.trim() !== '') || filters.status !== 'All';

  return (
    <EmptyResult
      icon={<Bot className="h-12 w-12 text-muted-foreground/40" />}
      title={
        hasQuery
          ? 'No agents found for the selected search criteria or filters'
          : 'No agents have been created yet.'
      }
      description={
        hasQuery
          ? 'Adjust or clear filters to view available agents.'
          : "Create your first agent by clicking 'Create an agent'."
      }
      hasQuery={hasQuery}
      onClear={reset}
      onCreate={() => emit('agents:create')}
      createButtonText="Create an agent"
    />
  );
};
